export default __webpack_public_path__ + "static/media/qr-code.06cb7e8e.svg";